<template>
  <main class="ws">

    <!-- ============ 首屏 ============ -->
    <section class="ph ph--gray ph--center">
      <div class="wrap">
        <span class="ph__kicker">{{ $t("卖家案例") }}</span>
        <h1 class="ph__title">{{ $t("他们也在做同一件事，") }}<br class="br-m">{{ $t("只是起点不一样") }}</h1>
        <p class="ph__sub">{{ $t("有人在义乌档口，有人在深圳写字楼，有人在德国的小公寓。") }}<b>{{ $t("难处不一样，解法是同一套。") }}</b></p>
        <div class="btns" style="justify-content:center">
          <router-link class="btn btn--primary" to="/sign-up">{{ $t("我也开一间试试") }}</router-link>
          <a class="btn btn--line" href="#stories">{{ $t("先看他们怎么做的") }}</a>
        </div>

        <div class="guide guide--center">
          <img class="guide__m" src="/website/img/tao-yay.png" alt="">
          <div class="bubble">{{ $t("这几位都不算「大神」。") }}<b>{{ $t("他们的共同点是先开了店，") }}</b>{{ $t("而不是先把一切都想明白。") }}</div>
        </div>
      </div>
    </section>

    <!-- ============ 汇总数据 ============ -->
    <section class="sec sec--tight">
      <div class="wrap">
        <div class="metrics">
          <div class="metric"><b>6</b><span>{{ $t("个不同起点的卖家") }}</span></div>
          <div class="metric"><b>14</b><span>{{ $t("天，最慢的一个开出第一单") }}</span></div>
          <div class="metric"><b>6</b><span>{{ $t("个语言站点，最多的一个") }}</span></div>
          <div class="metric"><b>480</b><span>{{ $t("月订单，最高的一个") }}</span></div>
        </div>
      </div>
    </section>

    <!-- ============ 六个案例 ============ -->
    <section class="sec sec--gray" id="stories">
      <div class="wrap">
        <div class="sec__head">
          <span class="eyebrow">{{ $t("六个故事") }}</span>
          <h2 class="sec__title">{{ $t("从左到右，是三种「卖出去」的路") }}</h2>
          <p class="sec__sub">{{ $t("前三个在中国，后三个在海外。") }}</p>
        </div>

        <div class="grid3">

          <article class="case">
            <div class="case__top">
              <div class="case__who">
                <span class="case__ava">{{ $t("陈") }}</span>
                <div>
                  <div class="case__name">{{ $t("陈女士") }}</div>
                  <div class="case__tag">{{ $t("义乌 · 饰品档口") }}</div>
                </div>
              </div>
              <p class="case__quote">{{ $t("「档口一天来不了几个老外，但网上的老外一天能来几百个。」") }}</p>
            </div>
            <div class="case__body">
              <p>{{ $t("原来只做批发，客户是本地贸易商。用模板做了英文和西班牙语两个站，把档口最常卖的 60 款拍了图上架，价格自己定。") }}</p>
            </div>
            <div class="case__nums">
              <div class="case__num"><b>0→480</b><span>{{ $t("月订单") }}</span></div>
              <div class="case__num"><b>2</b><span>{{ $t("语言站点") }}</span></div>
              <div class="case__num"><b>{{ $t("9 天") }}</b><span>{{ $t("开出第一单") }}</span></div>
            </div>
          </article>

          <article class="case">
            <div class="case__top">
              <div class="case__who">
                <span class="case__ava">{{ $t("林") }}</span>
                <div>
                  <div class="case__name">{{ $t("林先生") }}</div>
                  <div class="case__tag">{{ $t("深圳 · 3C 配件") }}</div>
                </div>
              </div>
              <p class="case__quote">{{ $t("「在平台卖，客户是平台的。在自己的站卖，客户才是我的。」") }}</p>
            </div>
            <div class="case__body">
              <p>{{ $t("原来在第三方平台做了三年，佣金加广告费吃掉三成。把爆款挪到独立站，用同一批货，客单价反而高了——因为能卖套装。") }}</p>
            </div>
            <div class="case__nums">
              <div class="case__num"><b>+34%</b><span>{{ $t("客单价") }}</span></div>
              <div class="case__num"><b>-18%</b><span>{{ $t("渠道成本") }}</span></div>
              <div class="case__num"><b>3</b><span>{{ $t("语言站点") }}</span></div>
            </div>
          </article>

          <article class="case">
            <div class="case__top">
              <div class="case__who">
                <span class="case__ava">{{ $t("王") }}</span>
                <div>
                  <div class="case__name">{{ $t("王小姐") }}</div>
                  <div class="case__tag">{{ $t("广州 · 女装") }}</div>
                </div>
              </div>
              <p class="case__quote">{{ $t("「我不碰国际物流。货发到国内仓，后面的事不归我管。」") }}</p>
            </div>
            <div class="case__body">
              <p>{{ $t("用代购模式起步：客户在她店里看到的是美元价，下单后平台买手去采购、合箱、出国际单。她只负责选款和在国内发货。") }}</p>
            </div>
            <div class="case__nums">
              <div class="case__num"><b>0</b><span>{{ $t("压货成本") }}</span></div>
              <div class="case__num"><b>4</b><span>{{ $t("人小团队") }}</span></div>
              <div class="case__num"><b>{{ $t("12 天") }}</b><span>{{ $t("回本周期") }}</span></div>
            </div>
          </article>

          <article class="case">
            <div class="case__top">
              <div class="case__who">
                <span class="case__ava">L</span>
                <div>
                  <div class="case__name">Lukas</div>
                  <div class="case__tag">{{ $t("德国 · 户外装备") }}</div>
                </div>
              </div>
              <p class="case__quote">{{ $t("「我不会中文，也没去过中国。但我能找到货源。」") }}</p>
            </div>
            <div class="case__body">
              <p>{{ $t("在德国做户外小众品类。通过平台直接对接国内工厂，一件代发，不压库存。页面用德语和英语，AI 员工处理夜间的英文询盘。") }}</p>
            </div>
            <div class="case__nums">
              <div class="case__num"><b>{{ $t("6–9 天") }}</b><span>{{ $t("到货时效") }}</span></div>
              <div class="case__num"><b>0</b><span>{{ $t("库存占用") }}</span></div>
              <div class="case__num"><b>2</b><span>{{ $t("语言站点") }}</span></div>
            </div>
          </article>

          <article class="case">
            <div class="case__top">
              <div class="case__who">
                <span class="case__ava">M</span>
                <div>
                  <div class="case__name">Maria</div>
                  <div class="case__tag">{{ $t("美国 · 手工材料") }}</div>
                </div>
              </div>
              <p class="case__quote">{{ $t("「利润不在货上，在搭配上。中国供应链让我敢试新组合。」") }}</p>
            </div>
            <div class="case__body">
              <p>{{ $t("卖手工材料包，按主题搭配。因为能小批量补货，她敢每周上一个新主题，卖不动就换，不用清库存。") }}</p>
            </div>
            <div class="case__nums">
              <div class="case__num"><b>{{ $t("每周") }}</b><span>{{ $t("上新频率") }}</span></div>
              <div class="case__num"><b>+52%</b><span>{{ $t("复购率") }}</span></div>
              <div class="case__num"><b>{{ $t("1 人") }}</b><span>{{ $t("团队规模") }}</span></div>
            </div>
          </article>

          <article class="case">
            <div class="case__top">
              <div class="case__who">
                <span class="case__ava">A</span>
                <div>
                  <div class="case__name">Amélie</div>
                  <div class="case__tag">{{ $t("法国 · 家居饰品") }}</div>
                </div>
              </div>
              <p class="case__quote">{{ $t("「我不懂投放。AI 给了我一整个月要发什么。」") }}</p>
            </div>
            <div class="case__body">
              <p>{{ $t("靠 Instagram 起量。用 AI 营销生成 30 天内容和投放计划，先小预算试，哪个帖子有反应就加钱。") }}</p>
            </div>
            <div class="case__nums">
              <div class="case__num"><b>5</b><span>{{ $t("渠道同时发") }}</span></div>
              <div class="case__num"><b>3.1%</b><span>{{ $t("帖子点击率") }}</span></div>
              <div class="case__num"><b>{{ $t("14 天") }}</b><span>{{ $t("首单") }}</span></div>
            </div>
          </article>

        </div>
      </div>
    </section>

    <!-- ============ 深挖一个 ============ -->
    <section class="sec">
      <div class="wrap">
        <div class="frow">
          <div>
            <span class="frow__tag">{{ $t("拆一个给你看") }}</span>
            <h2 class="frow__t">{{ $t("陈女士的头 90 天，做对了三件事") }}</h2>
            <p class="frow__d">{{ $t("她没投过广告，也没请运营。三件很朴素的事，按顺序做完，单量就起来了。") }}</p>
            <div class="steps" style="margin-top:24px">
              <div class="step">
                <span class="step__n">1</span>
                <div>
                  <div class="step__t">{{ $t("先只上 60 款，不贪多") }}</div>
                  <div class="step__d">{{ $t("档口卖得最好的款，实拍图上架。款式少，页面反而干净，客户挑得快。") }}</div>
                </div>
              </div>
              <div class="step">
                <span class="step__n">2</span>
                <div>
                  <div class="step__t">{{ $t("只开两个语言，做透") }}</div>
                  <div class="step__d">{{ $t("英文和西班牙语。没有一上来开 20 种，先把这两个市场的标题和描述改顺。") }}</div>
                </div>
              </div>
              <div class="step">
                <span class="step__n">3</span>
                <div>
                  <div class="step__t">{{ $t("把运费写清楚") }}</div>
                  <div class="step__d">{{ $t("多少钱、几天到、能不能退，写在商品页顶上。询盘少了一半，转化高了一截。") }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="frow__media">
            <div class="media-card">
              <div class="tl">
                <div class="tl__i on">
                  <div class="tl__t">{{ $t("第 90 天") }}</div>
                  <div class="tl__d">{{ $t("月订单稳定在 480 上下，开始备第二个语言站") }}</div>
                  <div class="tl__time">{{ $t("稳定期") }}</div>
                </div>
                <div class="tl__i on">
                  <div class="tl__t">{{ $t("第 32 天") }}</div>
                  <div class="tl__d">{{ $t("改了运费说明，商品页跳出率下降，开始有复购") }}</div>
                  <div class="tl__time">{{ $t("优化期") }}</div>
                </div>
                <div class="tl__i on">
                  <div class="tl__t">{{ $t("第 9 天") }}</div>
                  <div class="tl__d">{{ $t("第一单来自西班牙，两件饰品，客单 $34") }}</div>
                  <div class="tl__time">{{ $t("首单") }}</div>
                </div>
                <div class="tl__i">
                  <div class="tl__t">{{ $t("第 1 天") }}</div>
                  <div class="tl__d">{{ $t("选了模板，填店铺名，上传 60 款商品") }}</div>
                  <div class="tl__time">{{ $t("开店") }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ 说明 ============ -->
    <section class="sec sec--tight">
      <div class="wrap">
        <div class="note" style="max-width:760px;margin:0 auto">
          <svg class="ico"><use href="#i-doc"/></svg>
          <span><b>{{ $t("关于这些案例：") }}</b>{{ $t("人物姓名与店铺信息已做脱敏，数据为区间示意，用于说明做法而非承诺结果。每个人的品类、资金和执行力不同，结果会有差异。") }}</span>
        </div>
      </div>
    </section>

    <!-- ============ CTA ============ -->

    <section class="sec sec--tight">
      <div class="wrap">
        <div class="pandy">
          <img class="pandy__m" src="/website/img/tao-yay.png" alt="">
          <div>
            <p class="pandy__t">{{ $t("这几个人你都不认识") }}</p>
            <p class="pandy__b">{{ $t("但他们踩的坑，你大概率会踩。重点不是看他们赚了多少，而是") }}<b>{{ $t("看他们在哪个环节换了做法。") }}</b></p>

          </div>
        </div>
      </div>
    </section>

    <section class="sec sec--tight" style="padding-top:0">
      <div class="wrap">
        <div class="cta">
          <div>
            <h2 class="cta__t">{{ $t("你的起点，可能比他们还好一点") }}</h2>
            <p class="cta__d">{{ $t("先开一间免费的，把第一个款上架。剩下的边做边改。") }}</p>
          </div>
          <div class="cta__btns">
            <router-link class="btn btn--primary" to="/sign-up">{{ $t("免费开店") }}</router-link>
            <router-link class="btn btn--ghost" to="/for-china-sellers">{{ $t("我该走哪条路") }}</router-link>
          </div>
        </div>
      </div>
    </section>

  </main>
</template>

<script>
export default {
  name: 'WebsiteCases',
}
</script>
